import { createSlice } from "@reduxjs/toolkit";
const initialUserState = {
  recovery: {
    email: null,
    password: null,
    passwordConfirmation: null,
    loading: null,
    validToken: null,
  },
  register: {
    recaptcha_token: null,
    nationalIdNumber: null,
    contractNumber: null,
    email: null,
    cellphone: null,
    loading: null,
  },
  redirectTo: null,
};

const userSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    setRedirectTo(state, action) {
      state.redirectTo = action.payload;
    },
    setRecoveryEmail(state, action) {
      state.recovery.email = action.payload;
    },
    setRecoveryPassword(state, action) {
      state.recovery.password = action.payload;
    },
    setRecoveryPasswordConfirmation(state, action) {
      state.recovery.passwordConfirmation = action.payload;
    },
    setRecoveryLoading(state, action) {
      state.recovery.loading = action.payload;
    },
    setRecoveryValidToken(state, action) {
      state.recovery.validToken = action.payload;
    },
    setRegisterRecaptcha(state, action) {
      state.register.recaptcha_token = action.payload;
    },
    setRegisterNationalIdNumber(state, action) {
      state.register.nationalIdNumber = action.payload;
    },
    setRegisterContractNumber(state, action) {
      state.register.contractNumber = action.payload;
    },
    setRegisterEmail(state, action) {
      state.register.email = action.payload;
    },
    setRegisterCellphone(state, action) {
      state.register.cellphone = action.payload;
    },
    setRegisterLoading(state, action) {
      state.register.loading = action.payload;
    },
  },
});

export const userActions = userSlice.actions;

export default userSlice.reducer;
